/**
 * Variant type constants for type safety and consistency.
 * These values are used throughout the codebase to reference specific variants.
 * Note: Cohort names in the experiment match these variant names for simplicity.
 */
export const VARIANT_CLI = 'cli' as const;
export const VARIANT_CODE_REVIEW = 'code-review' as const;
export const VARIANT_CLI_AND_CODE_REVIEW = 'cli-and-code-review' as const;

/**
 * Experiment cohorts that are eligible to see this message.
 * Cohort names match variant names for consistency.
 * Used by both placement (Narrow Exposure check) and message template (implicit message creator eligibility check).
 */
export const ELIGIBLE_COHORTS: readonly ['cli-and-code-review', 'cli', 'code-review'] = [
	VARIANT_CLI_AND_CODE_REVIEW,
	VARIANT_CLI,
	VARIANT_CODE_REVIEW,
] as const;

export type EligibleCohort = (typeof ELIGIBLE_COHORTS)[number];

/**
 * Default variant to use as fallback when variantType is null.
 * Since placement already filters messages, if we reach render, we should always show something.
 */
export const DEFAULT_VARIANT: 'cli-and-code-review' = VARIANT_CLI_AND_CODE_REVIEW;
